<template>
    <div class="damage-form">
        <div class="row">
            <div class="col-md-12">
                <csp-form-group-datepicker :form="damageSubform" label-property="accidentDateTimeForCustomer"
                    property="accidentDateTime" required/>
            </div>
        </div>

        <h3 class="mt-4 mb-0">
            Wo ist der Unfall passiert?
        </h3>

        <b-tabs align="center" @activate-tab="accidentPlaceTabActivate">
            <b-tab active>
                <template v-slot:title>
                    <span class="tab-title">Ort eingeben</span>
                </template>
                <div class="tab-body">
                    <div class="form-group">
                        <gmap-autocomplete class="form-control" :value="accidentPlace" @place_changed="setPlace"/>
                    </div>
                </div>
            </b-tab>
            <b-tab>
                <template v-slot:title>
                    <span class="tab-title">Auf Karte suchen</span>
                </template>
                <div class="tab-body map-body text-center mb-3">
                    <div class="gmap-overflow-search">
                        <gmap-autocomplete :value="accidentPlace" @place_changed="setPlace"/>
                    </div>
                    <gmap-map
                        ref="map"
                        :center="maps.center"
                        :class="'mx-auto'"
                        style="width: 100%; height: 400px"
                        :zoom="12"
                        @click="markerHandling">
                        <GmapMarker v-if="maps.marker.lat" :position="maps.marker"/>
                    </gmap-map>
                </div>
            </b-tab>
        </b-tabs>

        <div class="row">
            <div class="col-md-12">
                <csp-form-group-radio :form="damageSubform" label-property="isRecordedByPoliceForCustomer"
                    :options="isRecordedByPoliceOptions" property="isRecordedByPolice"/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <csp-form-group-optional-bool align-horizontal :form="damageSubform"
                    :label-cols="null" label-property="isRentalCarUsedForCostumer" property="isRentalCarUsed"
                    type="text"/>
            </div>
        </div>
    </div>
</template>

<script>
    import Form from '@form/Form';
    import {gmapApi} from 'gmap-vue';
    import {buildOptionsYesNo} from '@js/functions/form/select';

    export default {
        props: {
            recordForm: {
                type: Form,
                required: true,
            },
        },
        data() {
            return {
                recordData: this.recordForm.getData(),
                maps: {
                    center: {
                        lat: 50.1065,
                        lng: 8.6622,
                    },
                    marker: {
                        lat: '',
                        lng: '',
                    },
                    customCenter: '',
                    initialPlaceSet: false,
                },
                isRecordedByPoliceOptions: [],
            }
        },
        computed: {
            accidentPlace() {
                return this.damageSubform.getData().accidentPlace;
            },
            damageSubform() {
                return this.recordForm.getSubform('damage');
            },
            google: gmapApi,
        },
        watch: {
            'recordData.damage.data.attributes.isRentalCarUsed'(newValue) {
                if (newValue === 'yes') {
                    this.damageSubform.getData().carRentalSource = 'intern';
                }

                this.damageSubform.getData().carRentalSource = null;
            },
        },
        async mounted() {
            this.isRecordedByPoliceOptions = await buildOptionsYesNo(false);
        },
        methods: {
            accidentPlaceTabActivate(newTabIndex) {
                if (!this.initialPlaceSet && 1 == newTabIndex) {
                    this.setPlaceToCurrentLocation()
                    this.initialPlaceSet = true
                }
            },
            setPlaceToCurrentLocation() {
                if (!navigator.geolocation) return
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const pos = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        };
                        this.maps.marker.lat = pos.lat;
                        this.maps.marker.lng = pos.lng;
                        this.maps.center = pos;
                        this.getFormattedAddress(this.maps.marker)
                    },
                    () => {
                        console.error('error while getting current location')
                    }
                )
            },
            setPlace(place) {
                this.setPlaceInFormData(place);

                if (place && place.geometry) {
                    this.maps.marker.lat = place.geometry.location.lat();
                    this.maps.marker.lng = place.geometry.location.lng();
                    this.changeCenter(place);
                }
            },
            setPlaceInFormData(place) {
                if (!place || !place.formatted_address) {
                    this.damageSubform.getData().accidentAddressComponents = [];
                    this.damageSubform.getData().accidentPlace = '';
                    return;
                }

                this.damageSubform.getData().accidentAddressComponents = place.address_components;
                this.damageSubform.getData().accidentPlace = place.formatted_address;
            },
            changeCenter(place) {
                this.maps.center = {
                    lat: place.geometry.location.lat,
                    lng: place.geometry.location.lng,
                }
            },
            markerHandling(event) {
                this.maps.marker.lat = event.latLng.lat();
                this.maps.marker.lng = event.latLng.lng();

                this.getFormattedAddress(event.latLng);
            },
            getFormattedAddress(latlng) {
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({'location': latlng}, (results, status) => {
                    if (status !== 'OK') {
                        this.setPlaceInFormData(null);
                        return;
                    }

                    this.setPlaceInFormData(results[0]);
                });
            },
        },
    }
</script>
